<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Cadastrar {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="name"
            :error-messages="formErrors.name"
            label="Nome"
            @input="formErrors.name = ''"
          />
          <v-text-field
            v-model="slug"
            :error-messages="formErrors.slug"
            label="Sigla / Abreviatura"
            @input="formErrors.slug = ''"
          />
          <v-text-field
            v-model="order"
            label="Ordem"
            @input="formErrors.order = ''"
          />
          <v-checkbox
            label="Continuar cadastrando"
            v-model="continueCreating"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar {{ title }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import handlesServerValidation from '@/mixins/handles-server-validation.js'
import slugify from 'slugify'
export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],
  props: {
    title: { type: String, default: undefined },
    action: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    name: '',
    slug: '',
    order: 0,
    continueCreating: false
  }),
  watch: {
    name (value) {
      this.slug = slugify(value).toLowerCase()
    }
  },
  computed: {
  },
  methods: {

    onCancel () {
      if (this.continueCreating) {
        this.$emit('resolve', true)
      }
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const data = {
        name: this.name,
        slug: slugify(this.slug).toLowerCase(),
        order: this.order
      }
      try {
        await this.action(data)
        this.$store.dispatch('setSnackBar', { text: `${this.title} cadastrado com sucesso!`, color: 'green' })
        if (this.continueCreating) {
          this.name = ''
          this.slug = ''
          this.order = 0
          this.$refs.form.resetValidation()
        } else {
          this.$emit('resolve', true)
        }
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: `Não foi possível salvar o ${this.title}, tente novamente mais tarde.`, color: 'red' })
      }
    }
  }
}
</script>
